import React from 'react';
import styled from 'styled-components';

const NodeActionsSpaceWrapper = styled.div`
  height: ${({ RowsCount }) => 34 * RowsCount}px;
`;
export const NodeActionsSpace = ({ rowsCount }) => <NodeActionsSpaceWrapper RowsCount={rowsCount} />;
